import React, { useState, useEffect } from 'react';
import TemplateCrudService from '../../services/TemplateCrudService';
import { Alert, Button, Col, Form, Modal, Row, Spinner, Tab, Tabs } from 'react-bootstrap';

export default function ModalMultiClients({ show, handleClose, dataItem, setRenderRows }) {

  const conditionView = (dataItem.typeView === 'View' || dataItem.typeView === 'Delete') ? true : false;
  const [successSend, setSuccessend] = useState(null);
  const [enableSaveChanges, setEnableSaveChanges] = useState(true);
  const [file, setFile] = useState();
  const [viewSpinner, setViewSpinner] = useState(false);
  const [disableBottonClose, setDisableBottonClose] = useState(false);

  useEffect(() => {
    if (!show) {
      setEnableSaveChanges(true);
      setSuccessend(null);
      setFile(null);
    } 
  }, [show]);

  function sleep(time){
    return new Promise((resolve)=>setTimeout(resolve,time)
    )
  }

  const handleSubmit = async () => {
    setViewSpinner(true);
    setEnableSaveChanges(true);
    setDisableBottonClose(true);
    const data = new FormData();
    data.append(`files[]`, file, file.name);
    
    TemplateCrudService.uploadZipTemplate(data).then(res => {

      setSuccessend('success');
      setViewSpinner(false);
      sleep(1500).then(()=>{
        handleClose();
        window.location.href = '/templates';
      })
    }).catch(err => {
      console.log(err);
      if (err.response.status !== 200) {
        setSuccessend('danger');
      } 
    }).finally(() => {
      setDisableBottonClose(false);
    })
  };

  const handleFileChange = (event) => {
    if (event.target.files) {
      const getFile = event.target.files[0];
      if(!getFile.type.includes('zip')) return;
      setFile(getFile);
      setEnableSaveChanges(false);
    }
  };

  let addSubmitButton = "";
  let fileData = (<h5>Choose a valid Zip File!</h5>);
  const setCloseButton = (<><Button variant="secondary" disabled={disableBottonClose} onClick={handleClose}> Close </Button> </>);

  if (!conditionView) {
    addSubmitButton = (<><Button type="button" disabled={enableSaveChanges} onClick={() => handleSubmit()} >Add Template</Button></>);
  }

  if (file) {        
      fileData = (file.type.includes('zip'))?(
        <div>
          <h5>File Details:</h5>
          <p>File Name: {file.name}</p>
          <p>File Type: {file.type}</p>
          <p>Last Modified:{" "} {file.lastModifiedDate.toDateString()} </p>
        </div>
      ):(<h5>'Provide a valid Zip File!'</h5>);
  }  

  return (
    <>
      <Modal size="lg" show={show} onHide={handleClose} backdrop="static">
        <Modal.Header>
          <Modal.Title> {dataItem.typeView} {dataItem.nameView} </Modal.Title>
        </Modal.Header>
        <Modal.Body>

          <Tabs
            defaultActiveKey="main"
            id="justify-tab-example"
            className="mb-3"
            justify
          >

            <Tab eventKey="main" title="Upload only Zip files">

              <Row className="mb-3">

                <Form.Group as={Col} md="6" controlId="controlId5">
                  <Form.Label>--</Form.Label>
                  <Form.Control
                    type="file"
                    accept=".zip"
                    placeholder="Template File"
                    onChange={conditionView ? null : handleFileChange}
                    readOnly={conditionView ? true : false}
                    disabled={conditionView ? true : false}
                  />
                </Form.Group>
              </Row>

              <div>{ fileData }</div>
              {viewSpinner && (
                <Spinner animation="border" role="status">
                  <span className="visually-hidden">Loading...</span>
                </Spinner>
          )}
              <hr></hr>
              {addSubmitButton}
              {'  '}  {'  '}
              {setCloseButton}
            </Tab>
          </Tabs>

          { (successSend == 'danger') ?
          (<Alert key='danger' variant='danger'> ¡Template no Add!</Alert>)
          :(successSend == 'success')?
          (<Alert key='success' variant='success'> ¡Template Added! </Alert>) : ""
          }
        </Modal.Body>
      </Modal>
    </>
  );
}